const WordPressHosting = () => {
    return <h1>404</h1>;
  };
  
  export default WordPressHosting;